angular.module('fundersclub.email', ['fundersclub.models']);
